import gsap from 'gsap'

import { fadeImageAnimation, SharedAnimation } from './shared'
import { Animation } from '@/types'

export const doubleImg = ({ node, reverse, mobile, context }: Animation) => {
  if (mobile) return

  const selector = context?.selector || gsap.utils.selector(node)

  const image = selector('[data-motion-image]')

  const scrollTrigger = {
    trigger: node,
    once: !reverse,
    start: 'top 80%',
    markers: false,
    toggleActions: `play none none ${reverse ? 'reverse' : 'none'}`
  }

  const timeline = gsap.timeline({
    scrollTrigger
  })

  let imageAnimation: SharedAnimation
  if (image) {
    imageAnimation = fadeImageAnimation(image)
    timeline.add(imageAnimation.timeline, '<')
  }

  return () => {
    if (imageAnimation) {
      imageAnimation.revert()
    }
  }
}
